import React from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
import noTour from "../assest/myImages/no-tour-img.png";
import Attraction from './Skeletons/Attraction';
import helper, { formatMeetingLocation, getSlugByLang, getSlugNameByLang } from '../common/Helper';
import { Link } from 'react-router-dom';
import ListLoading from './ListLoading';
import { useSelector } from 'react-redux';

const NearbyAttractions = ({
    productList,
    isLoading,
    title = "Attractions near you",
    attractionNearNextPageUrl,
    onClickLoadMore,
    isAttractionNearLoading,
    extClass = ""
}) => {
    const user = useSelector((state) => state.user);
    const slugField = getSlugNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)


    const options = {
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1.08
            },
            600: {
                items: 1.08
            }
        }
    };

    const handleImageError = (e) => {
        e.target.onerror = null;
        e.target.src = noTour;
    };

    // const TrustIndexScript = ({ index, tag }) => {


    //     useEffect(() => {
    //         const scriptId = `trustindex-script-${index}`;
    //         if (document.getElementById('pb_' + index) && tag) {
    //             let scriptTag = tag;
    //             let parser = new DOMParser();
    //             let doc = parser.parseFromString(scriptTag, 'text/html');
    //             let scriptSrc = doc.querySelector('script')?.getAttribute('src');

    //             const script = document.createElement('script');
    //             script.src = scriptSrc;
    //             script.id = scriptId;
    //             script.async = true;
    //             script.defer = true;
    //             document.getElementById('pb_' + index).innerHTML = ""
    //             document.getElementById('pb_' + index).appendChild(script)
    //             console.log('js', script);
    //             console.log('my', tag);


    //             // document.body.appendChild(script);
    //         }
    //     }, [index]); // Runs once when component mounts

    //     return null; // Does not render anything in the UI
    // };
    return (
        <>
            {
                !isLoading && (productList?.length === 0 || !productList?.length) ?
                    <></> :


                    <section className={`pageSection2 ${extClass}`}>
                        <div className="Section2Box">
                            <div className="container">
                                {
                                    isLoading ? 
                                      <div className="sectionTitle skeleton">
                                    <h3></h3>
                                </div> :
                                  <div className="sectionTitle">
                                    <h3>{productList?.length > 0 && title}</h3>
                                </div>
                                }
                            
                                <div className="placeSecDesktopFix">
                                    <div className="placeSec">
                                        <div className="row">

                                            {
                                                isLoading ?
                                                    <>
                                                        <Attraction records={6} />
                                                    </> :
                                                    productList?.length > 0 ?
                                                        productList.map((val, ind) => {

                                                            let amt = '';

                                                            if (val.product_rate_pricing_categories && val.product_rate_pricing_categories.length > 0) {
                                                                amt = val.product_rate_pricing_categories[0].lowest_amount;
                                                            } else if (val.product_rate_tiered_pricing_categories && val.product_rate_tiered_pricing_categories.length > 0) {
                                                                amt = val.product_rate_tiered_pricing_categories[0].lowest_amount;
                                                            }

                                                            const nonPrivateRates = val?.product_rates?.filter(rate => rate.availability_seat_type === 'non_private');
                                                            const privateRates = val?.product_rates?.filter(rate => rate.availability_seat_type === 'private');

                                                            return (
                                                                <div className="col-lg-4 col-md-6" key={val?.slug}>
                                                                    <Link to={(slugLang ? ('/' + slugLang) : '') + '/tour/' + val?.[slugField]} style={{ width: "100%", height: "100%" }}>
                                                                        <div className="travelBox">
                                                                            <div className="imgBox">
                                                                                <img
                                                                                    loading="lazy"
                                                                                    src={helper.S3Url + '/' + helper.productImageDir + '/' + val.cover_image}
                                                                                    alt={val?.cover_image_alternate_text}
                                                                                    onError={handleImageError}
                                                                                />
                                                                            </div>
                                                                            <div className="textBox">
                                                                                <p className="oneLine"><i className="fa-solid fa-location-dot"></i>

                                                                                    {/* {val?.product_detail?.meeting_point_location ? formatMeetingLocation(val?.product_detail?.meeting_point_location) : (val?.address ? val?.address : "-")} */}
                                                                                    {val?.product_detail?.meeting_point_location ?
                                                                                        formatMeetingLocation(val?.product_detail?.meeting_point_location) :
                                                                                        val?.product_detail?.location ?
                                                                                            formatMeetingLocation(val?.product_detail?.location)
                                                                                            : (val?.address ? val?.address : "-")}
                                                                                </p>
                                                                                <h6
                                                                                    data-bs-toggle="tooltip" data-bs-placement="top"
                                                                                    data-bs-custom-class="custom-tooltip"
                                                                                    data-bs-title="This top tooltip is themed via CSS variables."
                                                                                    title={val?.title}>{val?.title}</h6>
                                                                                <p className="min_height twoLine">{val?.short_description}</p>
                                                                                <ul>
                                                                                    {
                                                                                        nonPrivateRates.length > 0 &&
                                                                                        <li><p><i className="fa-solid fa-user-group"></i> Groups</p></li>
                                                                                    }
                                                                                    {
                                                                                        privateRates.filter((e) => e.availability_seat_type == 'private').length > 0 &&
                                                                                        <li><p><i className="fa-solid fa-user"></i> Private</p></li>
                                                                                    }
                                                                                    {
                                                                                        val?.duration &&
                                                                                        <li><p><i className="fa-solid fa-clock"></i> {val.duration}</p></li>
                                                                                    }
                                                                                </ul>

                                                                                <div className="priceBox" >
                                                                                    <div className='priceListTag'>
                                                                                        <h5>{amt ? 'From € ' + amt : ''}</h5>
                                                                                    </div>
                                                                                    <div id={'pb_' + ind} className='listRating'>
                                                                                        {val?.product_detail?.trustindex_rating != null && <div
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: val?.product_detail?.trustindex_rating
                                                                                            }}
                                                                                        />}
                                                                                        {/* <TrustIndexScript index={ind} tag={val?.product_detail?.trustindex_rating} /> */}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            )
                                                        }) :
                                                        // <h4>No Tours Found</h4>
                                                        <></>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {
                                    isAttractionNearLoading ? <ListLoading /> :
                                        productList?.length > 0 && attractionNearNextPageUrl &&

                                        <div className="showMore">
                                            <button
                                                className="btn showMoreBtn"
                                                onClick={() => onClickLoadMore('products', attractionNearNextPageUrl.split('=')[1])}

                                            >Show more <i className="fa-solid fa-chevron-right"></i></button>
                                        </div>
                                }
                            </div>
                        </div>
                    </section>

            }

        </>
    )

}
export default NearbyAttractions;